var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 12.5,
    rx: 7,
    ry: 6.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.915,
    y: 3,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(51.5462 21.915 3)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.999,
    y: 11,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(88.7664 25.999 11)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5156,
    y: 20.8238,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(139.886 23.5156 20.8238)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1348,
    y: 24.9982,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(178.441 15.1348 24.9982)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.09375,
    y: 22.6381,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(-134.257 5.09375 22.6381)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0742188,
    y: 14.1233,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(-91.4236 0.0742188 14.1233)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.20172,
    width: 3,
    height: 5,
    rx: 1.5,
    transform: "rotate(-47.2155 3 4.20172)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBtn);
export default __webpack_public_path__ + "static/media/LightBtn.534322eeb4248894ab3f2bb026876bdd.svg";
export { ForwardRef as ReactComponent };